exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.Wave__tab a {\n  font-weight: bold;\n  color: #ff533d;\n}\n.Wave__tab--released a {\n  font-style: italic;\n  color: #003153;\n}\n.Wave__tab--not-uploaded {\n  color: #ffbf00;\n}\n", "", {"version":3,"sources":["/app/src/views/Waves.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"Waves.vue","sourcesContent":["\n.Wave__tab a {\n  font-weight: bold;\n  color: #ff533d;\n}\n.Wave__tab--released a {\n  font-style: italic;\n  color: #003153;\n}\n.Wave__tab--not-uploaded {\n  color: #ffbf00;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Waves.vue
// module id = ko1P
// module chunks = 0